export var MARKETPLACE = 'Marketplace';
export var MARKETPLACE_NAMED_QUERIES = 'MarketplaceNamedQueries';
export var WORDPRESS = 'WordPress';
export var WORDPRESS_SEARCH = 'WordPressSearch';
export var WORDPRESS_TABLES = 'WordPressTables';